module.exports = __webpack_public_path__ + "img/nomessage.2e2e0e1d.png";